/**
 * Email Verification Hook
 * Automatically verifies email when user lands on home page via Firebase verification link
 * Detects ?mode=verifyEmail&oobCode=... query params and applies the action code silently
 */

import { useEffect } from 'react';
import { applyActionCode } from 'firebase/auth';
import { auth } from '@/firebase';
import { logger } from '@/utils/logger';

export const useEmailVerification = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oobCode = params.get('oobCode');
    const mode = params.get('mode');

    // Only proceed if this is an email verification action
    if (mode !== 'verifyEmail' || !oobCode) return;

    const verify = async () => {
      try {
        // Apply the Firebase email verification action code
        await applyActionCode(auth, oobCode);

        // Reload current user to refresh emailVerified status
        if (auth.currentUser) {
          await auth.currentUser.reload();
        }

        logger.log('useEmailVerification', 'Successfully verified email');
      } catch (error) {
        logger.error('useEmailVerification', 'Failed', error);
      } finally {
        // Clean up URL query params to avoid re-triggering or showing them to user
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };

    verify();
  }, []);
};
